<template>
  <main>
    <!--    <h3 id="title" :class="{feedTitle: isMini}">{{ dictionary.topTen.proTitle }}</h3>-->
    <!--    <tabs id="categoryTabs" :tabs="tabs" :active-tab="tab"/>-->

    <TableToolbar :buttons="['filter', 'info']" :id="'statusTopBar'"
      :info="hideNoteOnFilters.includes(tab) ? dictionary.messages.topVolume : dictionary.messages.topMktCap"
      :isFilterShown="showFilter" @cancelFilter="showFilter = false;" @toggleFilter="showFilter = !showFilter">
      <template #toolbarFilter="{ filterButtonRef }">
        <keep-alive>
          <ListFilter v-if="showFilter" @cancel="showFilter = false" ref="filterPanel" @applyFilter="applyFilter"
            :filterButtonRef="filterButtonRef" :defaultSelect="filters" />
        </keep-alive>
      </template>


      <template #main>
        <div>
          <div id="filterPanel">
            <div id="flexBlock">
              <DropDown :options="marketStatusButtons" width="140px" :default-selected="'tradingHours'"
                @select="activeButton = $event.value; loadTop(); setTab('gainers')" />

              <DropDown :options="categoryTabs" width="90px" class="showMobile" :default-selected="'gainers'"
                @select="setTab($event.value)" />

            </div>

            <tabs id="filterTabs" @tabClick="setTab" class="hideMobile" :transparent="true" :no-border="true"
              :round="true" :tabs="categoryTabs" :active-tab="categoryTabActive" />

            <div class="selectedIndex hideMobile">
              {{ selectedIndexLabel }}
            </div>
          </div>
          <div class="selectedIndex showMobile">
            {{ selectedIndexLabel }}
          </div>
        </div>

      </template>
    </TableToolbar>

    <big-loader v-if="isLoading"></big-loader>
    <section v-else ref="gainers">

      <DataGridTable :is-compact="true" :key="tableKey" :data="list" :hovered-columns="true" :loaded="isLoading"
        :customSort="[{ key: 'changeP', fn: priceSortValue }]" :height-decrease="17" :default-sort="defaultSort"
        :heightElements="['statusTopBar', 'title']" :default-sort-direction="defaultSortDirection" :fixed-col="0">
        <template #thead="{ thClick, sortKey, sortDirection, toggleSymbolActions, showSymbolActions, headers }">
          <HeadCell v-for="(th, thIndex) in headers" :key="`th-${thIndex}`" :sortKey="sortKey" :header="th"
            :sortDirection="sortDirection" :sortValue="th.sortValue" :showSymbolActions="showSymbolActions"
            @toggleSymbolActions="toggleSymbolActions()" @sort="thClick(th.sortValue, thIndex)">
            {{ th.label }}
          </HeadCell>
        </template>

        <template #tbody="{ rows, showSymbolActions }">
          <tr v-for="(row, rowIndex) in rows" :key="`r-${rowIndex}`">
            <td>
              <symbol-tag :tags="row.tags" :options="{ link: true, chart: true, logo: 'small' }"
                :showSymbolActions="showSymbolActions" :symbol="row.symbol" />
            </td>
            <!--            <td>{{ row.name }}</td>-->
            <td>
              <symbol-label :key="`s-${row.symbol}`" :pre-market-quote="row.preMarket"
                :post-market-quote="row.postMarket" :onlyPostMarket="activeButton === 'postMarket'"
                :onlyPreMarket="activeButton === 'preMarket'" :symbol="row.tradingData" :price-only="true"
                :force-pre-post="activeButton !== 'tradingHours'" :hide-pre-post="activeButton === 'tradingHours'"
                :show-prePost="activeButton !== 'tradingHours'" :always-on="true" />
            </td>
            <VolumeCell v-if="activeButton === 'tradingHours'" :volume="volumeValue(row)" :trend="row.tradingData?.volumeTrend" />
            <td v-else>N\A</td>


            <td>
              {{ row.tradingData.formattedMarketCap }}
            </td>

              <NumericCell :value="row.tradingData?.atr?.atrPercent" :ranges="[0, 1, 3, 5, 7]"
              :classes="['low', 'moderate', 'medium', 'high', 'extreme']" />
            <TrendIconCell :trend="row.tradingData?.atr?.atrTrend" />
            <TrendIconCell :trend="row.tradingData?.obvTrend" />
            <NumericCell v-for="period in ['5D', '10D', '1M']" :key="`n-${rowIndex}-${period}`"
              :value="row.eods?.[period]" />


            <PriceDistance :tag="'td'" :symbol="row.symbol" :threshold="3" :previousClose="row.tradingData?.price"
              :direction="'top'" :defaultPrice="row.tradingData?.price" :value="row.tradingData?.ma50"
              @deltaChange="deltaChange(row.symbol, $event, 'ma50D')" />
            <PriceDistance :tag="'td'" :symbol="row.symbol" :threshold="3" :previousClose="row.tradingData?.price"
              :direction="'bottom'" :defaultPrice="row.tradingData?.price" :value="row.tradingData?.ma200"
              @deltaChange="deltaChange(row.symbol, $event, 'ma200D')" />

            <YearlyRangeCell :delta-change="this.deltaChange" :row="row" />

            <RSICell :rsi="row.tradingData?.rsi" />
            <MACDCell :macd="row.tradingData?.macd" />
          
            <NumericCell :noColor="true" :value="row.tradingData?.eps" />
            <NumericCell :noColor="true" :value="row.tradingData?.pe" />
            <IndustrySectorCell :symbol="row" />
            <!--            <td>{{ row.sector }}</td>-->
            <!--            <td>{{ row.industry }}</td>-->
          </tr>
        </template>
      </DataGridTable>

    </section>

  </main>
</template>

<script>

import TopTen from '../services/topTen';
import SymbolLabel from "../components/symbols/symbol";
import BigLoader from "../components/ui/BigLoader";
import DataGridTable from "../components/dataGrid/DataGridTable";
import Tabs from "../components/ui/Tabs";
import HeadCell from "../components/dataGrid/HeadCell";
import SymbolLogo from "../components/symbols/symbolLogo";
import UserService from "../services/user";
import { useWatchlist } from "../stores/watchlist";
import DropDown from "../components/ui/DropDown";
import SymbolLink from "../components/symbols/symbolLink";
import BigNote from "../components/ui/BigNote";
import VolumeCell from "../components/dataGrid/VolumeCell";

import quoteStreaming from "../composables/quoteStreaming";
import ButtonsGroup from "../components/ui/ButtonsGroup";
import { useNewYorkTime } from "../stores/newYorkTime";
import ListFilter from "../components/filter/ListFilter";
import TableToolbar from "../components/ui/TableToolbar";
import PriceDistance from "../components/priceTags/priceDistance";
import SymbolChart from "../components/symbols/symbolChart";
import SymbolTag from "../components/symbols/symbolTag";
import PriceRange from "../components/priceTags/priceRange";
import NumericCell from "../components/dataGrid/NumericCell";
import YearlyRangeCell from "../components/dataGrid/YearlyRangeCell";
import RSICell from "../components/dataGrid/RSICell";
import MACDCell from "../components/dataGrid/MACDCell";
import TrendIconCell from "../components/dataGrid/TrendIconCell";
import IndustrySectorCell from "../components/dataGrid/IndustrySectorCell";

export default {
  name: "TopTenPro",
  components: {
    VolumeCell,
    IndustrySectorCell,
    TrendIconCell,
    MACDCell,
    RSICell,
    YearlyRangeCell,
    NumericCell,
    PriceRange,
    SymbolTag,
    SymbolChart,
    PriceDistance,
    TableToolbar,
    ListFilter,
    ButtonsGroup,
    BigNote, SymbolLink, DropDown, SymbolLogo, HeadCell, Tabs, DataGridTable, BigLoader, SymbolLabel
  },
  props: ['prices', 'isMini'],
  setup() {

    const marketStatus = useNewYorkTime();
    const { updateStream, leaveStream } = quoteStreaming();
    return { updateStream, leaveStream, marketStatus };
  },
  data() {
    return {
      showFilter: false,
      gainers: [],
      losers: [],
      active: [],
      watchlist: useWatchlist(),
      filters: { index: ['sp500'] },
      tab: 'sp500',
      selectedIndex: [this.dictionary.topTen.sp],
      defaultSort: 'changeP',
      defaultSortDirection: -1,
      categoryTabActive: 'gainers',
      hideNoteOnFilters: ['nasdaq100',
        'sp500',
        'microCap',
        'smallCap',
        'midCap',
        'largeCap',
        'megaCap'],
      tableKey: 0,
      activeButton: 'tradingHours',
      marketStatusButtons: [{
        value: 'preMarket',
        label: 'Pre-market'
      }, {
        value: 'tradingHours',
        label: 'Trading hours'
      }, {
        value: 'postMarket',
        label: 'Post-market'
      }],
      headers: [{
        label: this.dictionary.symbolPage.symbol,
        sortValue: 'symbol'
      },
      // {
      //   label: this.dictionary.symbolPage.name,
      // },
      {
        label: this.dictionary.symbolPage.price,
        sortValue: this.priceSortValue,
      }, {
        label: this.dictionary.symbolPage.volume,
        sortValue: this.volumeSortValue
      },
      {
        label: this.dictionary.symbolPage.marketCap,
        sortValue: 'tradingData.marketCap'
      },
      {
        label: this.dictionary.trendingStocks.priceChange + ' ' + this.dictionary.chart.periods['5d'],
        sortValue: 'eods.5D'
      },
      {
        label: this.dictionary.trendingStocks.priceChange + ' ' + this.dictionary.chart.periods['1m'],
        sortValue: 'eods.1M'
      },
      {
        label: this.dictionary.trendingStocks.priceChange + ' ' + this.dictionary.chart.periods['6m'],
        sortValue: 'eods.6M'
      },
      {
        label: this.dictionary.symbolPage.ma50,
        sortValue: 'ma50D'
      },
      {
        label: this.dictionary.symbolPage.ma200,
        sortValue: 'ma200D'
      },
      {
        label: this.dictionary.symbolPage.fiftyTwoWeeksLow,
        sortValue: '52wlD'
      },
      {
        label: this.dictionary.symbolPage.yearlyRange,
        sortValue: 'tradingData.yearlyRange'
      },
      {
        label: this.dictionary.symbolPage.fiftyTwoWeeksHigh,
        sortValue: '52whD'
      },
      {
        label: this.dictionary.symbolPage.sector,
        sortKey: 'sector'
      }, {
        label: this.dictionary.symbolPage.industry,
        sortKey: 'industry'
      }],
      categoryTabs: [{
        value: 'gainers',
        label: this.dictionary.topTen.gainers
      }, {
        value: 'losers',
        label: this.dictionary.topTen.losers
      }, {
        value: 'active',
        label: this.dictionary.topTen.active
      }],
      topTen: null,
      isLoading: true,
      tabs: [{
        value: 'market',
        label: this.dictionary.topTen.market
      }, {
        value: 'nasdaq100',
        label: 'NASDAQ 100'
      }, {
        value: 'sp500',
        label: 'S&P500'
      },
      { value: 'microCap', label: this.dictionary.topTen.microCap },
      { value: 'smallCap', label: this.dictionary.topTen.smallCap },
      { value: 'midCap', label: this.dictionary.topTen.midCap },
      { value: 'largeCap', label: this.dictionary.topTen.largeCap },
      { value: 'megaCap', label: this.dictionary.topTen.megaCap },
      { value: 'Communication Services', label: this.dictionary.topTen.sectors['Communication Services'] },
      { value: 'Consumer Cyclical', label: this.dictionary.topTen.sectors['Consumer Cyclical'] },
      { value: 'Energy', label: this.dictionary.topTen.sectors['Energy'] },
      { value: 'Financial Services', label: this.dictionary.topTen.sectors['Financial Services'] },
      { value: 'Real Estate', label: this.dictionary.topTen.sectors['Real Estate'] },
      { value: 'Technology', label: this.dictionary.topTen.sectors['Technology'] },
      { value: 'Basic Materials', label: this.dictionary.topTen.sectors['Basic Materials'] },
      { value: 'Industrials', label: this.dictionary.topTen.sectors['Industrials'] },
      { value: 'Utilities', label: this.dictionary.topTen.sectors['Utilities'] },
      { value: 'Consumer Defensive', label: this.dictionary.topTen.sectors['Consumer Defensive'] },
      { value: 'Healthcare', label: this.dictionary.topTen.sectors['Healthcare'] }],
      loadingInterval: null
    }
  },
  computed: {
    selectedIndexLabel() {

      return this.selectedIndex.join(', ')
    },
    showPrePost() {

      if ((this.marketStatus.isPreMarket || this.marketStatus.isPostMarket) && this.activeButton !== 'tradingHours') return true;
      if (this.activeButton !== 'tradingHours') return true;
    },
    list() {
      if (!this.topTen) return [];
      if (this.categoryTabActive === 'gainers') {
        this.defaultSort = this.priceSortValue();
        this.defaultSortDirection = -1;
        return this.gainers;
      }
      if (this.categoryTabActive === 'losers') {
        this.defaultSort = this.priceSortValue();
        this.defaultSortDirection = 1;
        return this.losers;
      }
      if (this.categoryTabActive === 'active') {
        this.defaultSort = this.volumeSortValue();
        this.defaultSortDirection = -1;
        return this.active;
      }
    }
  },
  methods: {
    deltaChange(symbol, value, key) {

      if (this.categoryTabActive === 'gainers') {
        this.gainers = this.gainers.map(row => {

          if (row.symbol === symbol) row[key] = value;
          return row;
        });
      }
      if (this.categoryTabActive === 'losers') {

        this.losers = this.losers.map(row => {

          if (row.symbol === symbol) row[key] = value;
          return row;
        });
      }
      if (this.categoryTabActive === 'active') {

        this.active = this.active.map(row => {

          if (row.symbol === symbol) row[key] = value;
          return row;
        });
      }

    },
    async applyFilter(filters) {

      this.filters = filters;

      if (filters.index.length > 0) {

        this.selectedIndex = filters.index.map(index => {

          if (index === 'sp500') return 'S&P 500';
          if (index === 'nasdaq100') return 'NASDAQ 100';
          if (index === 'russell2000') return 'Russell 2000';
        })
      } else {
        this.selectedIndex = [this.dictionary.topTen.market];
      }

      if (window.innerWidth <= 768) {

        this.showFilter = false;
      }
      await this.loadTop(true);
    },
    priceSortValue() {
      return this.activeButton === 'tradingHours' ? 'tradingData.changeP' : this.activeButton === 'preMarket' ? 'preMarket.changeP' : 'postMarket.changeP';
    },
    volumeSortValue() {
      return this.activeButton === 'tradingHours' ? 'tradingData.volume' : this.activeButton === 'preMarket' ? 'preMarket.volume' : 'postMarket.volume';
    },
    volumeValue(row) {

      if (this.activeButton === 'tradingHours') return row.tradingData.formattedVolume;
      if (this.activeButton === 'preMarket') return row.preMarket.formattedVolume;
      if (this.activeButton === 'postMarket') return row.postMarket.formattedVolume;
    },
    setTab(tab) {

      this.categoryTabActive = tab;

      if (tab === 'gainers') {
        this.defaultSort = this.priceSortValue();
        this.defaultSortDirection = -1;
      }
      if (tab === 'losers') {
        this.defaultSort = this.priceSortValue();
        this.defaultSortDirection = 1;
      }
      if (tab === 'active') {
        this.defaultSort = this.volumeSortValue();
        this.defaultSortDirection = -1;
      }

      this.tableKey++;
    },
    async addRemoveWatchlistSymbol(symbol) {

      if (this.watchlist.watchlist.includes(symbol)) {

        try {
          mixpanel.track('symbol:remove', { client: window.location.host, symbol: symbol });
        } catch (e) {
        }

        const watchlist = await UserService.removeSymbolFromWatchlist(symbol)
        this.watchlist.updateWatchlist(watchlist);
      } else {

        try {
          mixpanel.track('symbol:add', { client: window.location.host, symbol: symbol });
        } catch (e) {
        }
        const watchlist = await UserService.addSymbolToWatchlist(symbol)
        this.watchlist.updateWatchlist(watchlist);
      }
    },
    async loadTop(showLoading = true, shouldLeave = true) {

      if (showLoading) this.isLoading = true;

      this.leaveStream('topten');
      this.topTen = await TopTen.getTopTenPro({ filters: this.filters, tradingTime: this.activeButton, gOnly: true });
      this.gainers = this.topTen.gainers;
      if (showLoading) this.isLoading = false;

      this.topTen = await TopTen.getTopTenPro({ filters: this.filters, tradingTime: this.activeButton, gOnly: false });
      this.losers = this.topTen.losers;
      this.active = this.topTen.active;

      let symbols = [
        ...this.gainers.map(item => item.symbol),
        ...this.losers.map(item => item.symbol),
        ...this.active.map(item => item.symbol),
      ];

      this.updateStream(symbols, 'topten');
    }
  },
  beforeUnmount() {
    this.leaveStream('topten');
    clearInterval(this.loadingInterval);
  },
  beforeMount() {
    this.loadTop().then().catch();
    this.loadingInterval = setInterval(() => {

      this.loadTop(false).then().catch()
    }, 1000 * 60);
  }
}
</script>

<style scoped lang="scss">
@import "../assets/style/vars";
@import "../assets/style/calendar";
@import "../assets/style/general";

.tab {
  width: 33%;

}

.symbolRow {
  border-bottom: 1px solid var(--notficationBorderColor);
  padding: $smallGap;

  &:last-of-type {
    border-bottom: none;
  }
}

h2 {
  margin: 0 $smallGap $smallGap;
  padding: 0;
}

h3 {
  color: var(--textColor);
  margin: 0;
  padding: 5px 10px;

}

#topTable {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;

  section {
    width: 100%;
  }
}

.symbolTd {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;

  a {
    z-index: 1;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
}

.addRemoveSymbol {
  flex: 0 0 55px !important;
  width: 45px;
  margin-left: auto;

  &[dir="rtl"] {
    margin-left: unset;
    margin-right: auto;
  }

  i {
    display: none;
  }

  @media(max-width: 660px) {

    flex: 0 0 30px !important;
    width: 30px;
    height: 20px;
    box-sizing: border-box;
    justify-content: center;
    align-items: center;

    i {
      display: block;
    }

    span {
      //display: none;
    }
  }
}

.tabs.round {
  z-index: 2;
  padding: 3px 5px !important;
  margin: 0 !important;
}

#filterPanel {
  padding: 0;
  display: flex;
  align-items: center;
  gap: 1rem;

  @media(max-width: 768px) {
    margin-top: .5rem;
  }

  #flexBlock {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  @media(max-width: 660px) {}

}

#topBar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--notficationBorderColor) !important;

  @media(max-width: 660px) {
    display: block;
  }
}

.tabs:not(.round) {
  position: unset;
}


.selectedIndex {
  text-align: center;
  background: var(--lightYellowOpacity);
  border: 1px solid var(--lightYellow);
  padding: 2px 7px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  color: var(--textColor);
  margin: 0 .5rem 0 0;

  @media(max-width: 768px) {
    margin: .5rem 0;
  }
}
</style>
